/**
 * A single chat message bubble.
 * User messages are right-aligned with a sky background.
 * Assistant messages are left-aligned with a slate background.
 */

export type MessageRole = 'user' | 'assistant';

export type ChatMessageProps = {
  role: MessageRole;
  content: string;
  /** True while the assistant message is still streaming in */
  streaming?: boolean;
};

export function ChatMessage({ role, content, streaming = false }: ChatMessageProps) {
  const isUser = role === 'user';

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={[
          'max-w-[80%] rounded-lg px-4 py-3 text-sm leading-relaxed',
          isUser
            ? 'bg-sky-900/60 border border-sky-700/40 text-sky-100 ml-8'
            : 'bg-slate-800/70 border border-slate-700/40 text-slate-200 mr-8',
        ].join(' ')}
      >
        <p className="whitespace-pre-wrap break-words">
          {content}
          {streaming && (
            <span className="inline-block w-1.5 h-4 ml-1 bg-slate-400 animate-pulse align-middle" />
          )}
        </p>
      </div>
    </div>
  );
}
